export const bodyWrapperId = 'bodyWrapperId';
export const popupWrapperId = 'popup';
